export function selectionHasAssignedStudies(
  allStudies: Array<{ studyInstanceUid: string; assignedName?: unknown }>,
  checkedStudyInstanceUids: Set<string>
) {
  const selectedStudies = allStudies.filter(studyRow => {
    return checkedStudyInstanceUids.has(studyRow.studyInstanceUid);
  });

  return selectedStudies.some(studyRow => {
    const assignedName =
      typeof studyRow.assignedName === 'string'
        ? studyRow.assignedName
        : String(studyRow.assignedName || '');
    return Boolean(assignedName.trim() !== '');
  });
}

export function getStudyHubFacilityId(study: { assignedHubFacilityId?: unknown }): string {
  if (typeof study.assignedHubFacilityId === 'string') {
    return study.assignedHubFacilityId.trim();
  }
  return String(study.assignedHubFacilityId || '').trim();
}

export function isStudyHubAssigned(study: { assignedHubFacilityId?: unknown }): boolean {
  return getStudyHubFacilityId(study) !== '';
}

export function selectionHasHubAssignedStudies(
  allStudies: Array<{ studyInstanceUid: string; assignedHubFacilityId?: unknown }>,
  checkedStudyInstanceUids: Set<string>
): boolean {
  const selectedStudies = allStudies.filter(studyRow =>
    checkedStudyInstanceUids.has(studyRow.studyInstanceUid)
  );

  return selectedStudies.some(isStudyHubAssigned);
}

export type HubAssignmentSelectionState = 'none' | 'all' | 'mixed';

export function getSelectionHubAssignmentState(
  selectedStudies: Array<{ assignedHubFacilityId?: unknown }>
): HubAssignmentSelectionState {
  if (selectedStudies.length === 0) {
    return 'none';
  }

  const assignedCount = selectedStudies.filter(isStudyHubAssigned).length;
  if (assignedCount === 0) {
    return 'none';
  }
  if (assignedCount === selectedStudies.length) {
    return 'all';
  }
  return 'mixed';
}

export function isHubReassignBlocked(study: { reportStatus?: string }): boolean {
  const status = study.reportStatus?.trim().toLowerCase() || '';
  return status === 'awaiting review' || status === 'approved';
}
